import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { getOrderDataById, orderEasyUpdate } from '../../../../services/clinicPortalServices/orderEditService';
import { approveReport } from '../../../../services/clinicPortalServices/orderSearchService';
import { Autocomplete, TextField } from '@mui/material';
import { ModalStyled } from '../../../../theme/customizedStyleComponents';
import { individualTestStatuses, orderStatuses, reportStatuses } from '../../../../services/common/optionsData';
import { getUserRole } from '../../../../services/common/util';
import toastr from 'toastr';

export default class OrderStatusPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderDetails: null,
            status: '',
            reportStatus: '',
            saving: false
        };
    }

    componentDidMount() {}

    componentDidUpdate(prevProps) {
        if (this.props.show && this.props.show !== prevProps.show) {
            getOrderDataById(this.props.data._id).then((res) => {
                this.setState({
                    orderDetails: res.data,
                    status: res.data.status,
                    reportStatus: res.data.report_status || '',
                    saving: false
                });
            });
        }
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleSave = () => {
        const statusChanged = this.state.status !== this.state.orderDetails.status;
        const reportStatusChanged = (this.state.reportStatus || '') !== (this.state.orderDetails.report_status || '');

        if (!statusChanged && !reportStatusChanged) return;

        this.setState({ saving: true });

        // If report_status is being set to 'final', use the approveReport endpoint
        if (reportStatusChanged && this.state.reportStatus === 'final') {
            approveReport({ orderId: this.state.orderDetails._id }).then((res) => {
                if (res && res.status === 200) {
                    // If order status also changed, update it separately
                    if (statusChanged) {
                        let params = {
                            _id: this.state.orderDetails._id,
                            status: this.state.status
                        };
                        orderEasyUpdate(params).then(() => {
                            toastr.success('Order and report status updated');
                            this.props.context.componentParent.loadGridData();
                            this.props.handleClose();
                        });
                    } else {
                        toastr.success('Report approved succesfully');
                        this.props.context.componentParent.loadGridData();
                        this.props.handleClose();
                    }
                } else {
                    toastr.error(res?.message || 'Error approving report');
                    this.setState({ saving: false });
                }
            }).catch(() => {
                toastr.error('Error approving report');
                this.setState({ saving: false });
            });
        } else {
            // Standard easyUpdate for status and/or report_status changes
            let params = { _id: this.state.orderDetails._id };
            if (statusChanged) {
                params.status = this.state.status;
            }
            if (reportStatusChanged) {
                params.report_status = this.state.reportStatus || null;
            }
            orderEasyUpdate(params).then((response) => {
                toastr.success('Order updated succesfully');
                this.props.context.componentParent.loadGridData();
                this.props.handleClose();
            }).catch(() => {
                toastr.error('Error updating order');
                this.setState({ saving: false });
            });
        }
    };

    getReportStatusBadgeStyle = (val) => {
        if (!val) return {};
        const colors = {
            draft: { backgroundColor: '#6c757d', color: '#fff' },
            preliminary: { backgroundColor: '#fd7e14', color: '#fff' },
            final: { backgroundColor: '#28a745', color: '#fff' }
        };
        return {
            ...(colors[val] || {}),
            padding: '2px 8px',
            borderRadius: '12px',
            fontSize: '12px',
            fontWeight: 600,
            textTransform: 'uppercase',
            display: 'inline-block'
        };
    };

    render() {
        const userRole = getUserRole();
        const isAdminOrSuper = ['SuperAdmin', 'Admin'].includes(userRole);
        const hasReportStatus = this.state.orderDetails && this.state.orderDetails.report_status;

        // Report status options based on role
        let reportStatusOptions = ['', ...reportStatuses];
        if (!isAdminOrSuper) {
            // Non-admins cannot set to 'final'
            reportStatusOptions = reportStatusOptions.filter((s) => s !== 'final');
        }

        const statusChanged = this.state.orderDetails && this.state.status !== this.state.orderDetails.status;
        const reportStatusChanged = this.state.orderDetails && (this.state.reportStatus || '') !== (this.state.orderDetails.report_status || '');
        const hasChanges = statusChanged || reportStatusChanged;

        const reportStatusEligibleStatuses = ['Pending Review', 'Resulted', 'On Hold'];
        const showReportStatus = this.state.orderDetails && reportStatusEligibleStatuses.includes(this.state.orderDetails.status);

        return (
            <ModalStyled
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.props.show}
                onHide={this.props.handleClose}
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Update Order Status</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.state.orderDetails && (
                        <div className="row">
                            <div className="col-12">
                                Current Status: <strong>{this.state.orderDetails.status}</strong>
                            </div>
                            <div className="col-12 mt-3">
                                <Autocomplete
                                    options={
                                        this.state.orderDetails.order_type === 'root'
                                            ? orderStatuses
                                            : individualTestStatuses
                                    }
                                    value={this.state.status}
                                    onChange={(event, newValue) => {
                                        this.setState({
                                            status: newValue
                                        });
                                    }}
                                    getOptionLabel={(option) => (option ? option : '')}
                                    renderInput={(params) => (
                                        <TextField {...params} variant="outlined" label="Order Status *" />
                                    )}
                                />
                            </div>
                            {showReportStatus && (
                                <div className="col-12 mt-4" style={{ borderTop: '1px solid #dee2e6', paddingTop: '16px' }}>
                                    <div className="d-flex align-items-center mb-2">
                                        <span>Current Report Status:&nbsp;</span>
                                        {hasReportStatus ? (
                                            <span style={this.getReportStatusBadgeStyle(this.state.orderDetails.report_status)}>
                                                {this.state.orderDetails.report_status}
                                            </span>
                                        ) : (
                                            <span style={{ color: '#999' }}>None</span>
                                        )}
                                    </div>
                                    {this.state.orderDetails.report_review && (
                                        <div style={{ fontSize: '12px', color: '#666', marginBottom: '8px' }}>
                                            {this.state.orderDetails.report_review.preliminary_by && (
                                                <div>
                                                    Preliminary by: {this.state.orderDetails.report_review.preliminary_by}
                                                    {this.state.orderDetails.report_review.preliminary_at && (
                                                        <span> ({new Date(this.state.orderDetails.report_review.preliminary_at).toLocaleString()})</span>
                                                    )}
                                                </div>
                                            )}
                                            {this.state.orderDetails.report_review.approved_by && (
                                                <div>
                                                    Approved by: {this.state.orderDetails.report_review.approved_by}
                                                    {this.state.orderDetails.report_review.approved_at && (
                                                        <span> ({new Date(this.state.orderDetails.report_review.approved_at).toLocaleString()})</span>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                    <Autocomplete
                                        options={reportStatusOptions}
                                        value={this.state.reportStatus}
                                        onChange={(event, newValue) => {
                                            this.setState({
                                                reportStatus: newValue || ''
                                            });
                                        }}
                                        getOptionLabel={(option) => {
                                            if (!option) return 'None';
                                            return option.charAt(0).toUpperCase() + option.slice(1);
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params} variant="outlined" label="Report Status" />
                                        )}
                                    />
                                    {reportStatusChanged && this.state.reportStatus === 'final' && (
                                        <div style={{ marginTop: '8px', fontSize: '13px', color: '#28a745' }}>
                                            <i className="fas fa-info-circle"></i>&nbsp;
                                            Setting to Final will regenerate the PDF without watermark and set order status to Reported.
                                        </div>
                                    )}
                                    {reportStatusChanged && this.state.reportStatus === 'final' && !isAdminOrSuper && (
                                        <div style={{ marginTop: '4px', fontSize: '13px', color: '#dc3545' }}>
                                            <i className="fas fa-exclamation-triangle"></i>&nbsp;
                                            Only Admin or SuperAdmin can approve reports to Final.
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.props.handleClose}>
                        Close
                    </Button>
                    <Button
                        variant="primary"
                        onClick={this.handleSave}
                        disabled={!hasChanges || this.state.saving}
                    >
                        {this.state.saving && (
                            <i className="fa fa-refresh fa-spin" style={{ marginRight: '5px' }}></i>
                        )}
                        Save
                    </Button>
                </Modal.Footer>
            </ModalStyled>
        );
    }
}
